"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.takeWhile = void 0;
/* Returns elements from arr until the predicate returns false. */
function takeWhile(arr, predicate) {
    const result = [];
    for (const item of arr) {
        if (!predicate(item)) {
            break;
        }
        result.push(item);
    }
    return result;
}
exports.takeWhile = takeWhile;
//# sourceMappingURL=util.js.map